import type { CSSProperties } from "react";
import bg1 from "../../assets/images/quiz-bg/quiz-bg-1.png";
import bg2 from "../../assets/images/quiz-bg/quiz-bg-2.png";
import bg3 from "../../assets/images/quiz-bg/quiz-bg-3.png";
import bg4 from "../../assets/images/quiz-bg/quiz-bg-4.png";
import bg5 from "../../assets/images/quiz-bg/quiz-bg-5.png";
import bg6 from "../../assets/images/quiz-bg/quiz-bg-6.png";
import bgOpella from "../../assets/images/quiz-bg/quiz-bg-opella.png";
import { useRoomOrganization } from "../../domains/room/hooks/useRoomOrganization";
import type { PrivateRoom } from "../../domains/room/privateRoom";
import { CardContainer, CardRow, CardTitle, CardType } from "./layout";

const backgrounds = [bg1, bg2, bg3, bg4, bg5, bg6];

export interface QuizTranslation {
  title: string;
  subtitle: string | null;
}

export default function RoomQuizCard({
  index,
  room,
  translation,
  onclick,
  eventName,
}: {
  index: number;
  room: PrivateRoom;
  translation: QuizTranslation;
  onclick: () => void;
  eventName: string | null;
}) {
  const { isOpellaRoom } = useRoomOrganization(null);
  const backgroundUrl = isOpellaRoom
    ? bgOpella
    : backgrounds[index % backgrounds.length];
  const backgroundBlendColor = isOpellaRoom
    ? (room.primaryColor ?? undefined)
    : undefined;

  return (
    <CardContainer
      backgroundUrl={backgroundUrl}
      onClick={() => {
        onclick();
      }}
      style={{ minHeight: "unset" }}
      colorLayerOverrides={{
        background: backgroundBlendColor ?? "#411772",
        mixBlendMode: "hard-light",
      }}
      contentStyleOverrides={
        {
          padding: "56px 16px",
          color: "#ffffff",
          ["--card-primary-color" as string]: "#ffffff",
          ["--card-secondary-color" as string]: "var(--color-primary-yellow)",
        } as CSSProperties
      }
      backgroundImage={null}
    >
      <CardRow $gap={20} style={{ alignItems: "center" }}>
        <div style={{ display: "flex", flexDirection: "column", gap: "6px" }}>
          {translation.subtitle !== null && (
            <CardType>{translation.subtitle}</CardType>
          )}
          <CardTitle lines={3}>{translation.title}</CardTitle>
          <div
            style={{
              marginTop: 24,
              display: "flex",
              flexDirection: "column",
              gap: 24,
            }}
          >
            {eventName !== null && <span>{eventName}</span>}
          </div>
        </div>
      </CardRow>
    </CardContainer>
  );
}
